import { TIER_META, type Tier } from "../lib/tier";

interface Props {
  tier: string;
}

/** Quiet 3-bar signal-strength glyph indicating refresh cadence.
 * Live = 3 bars, Tracked = 2, Idle = 1. The glyph is intentionally small
 * and grayscale — tier is configuration, not signal, so it shouldn't
 * compete with the rating/score chips next to it. */
export default function CadenceDial({ tier }: Props) {
  const meta = TIER_META[tier as Tier];
  if (!meta) return null;
  const bars = meta.bars;
  const tooltip = `${meta.label} · ${meta.cadence}${meta.llm ? " · daily analysis" : " · no auto-analysis"}`;

  return (
    <span
      title={tooltip}
      aria-label={`Cadence: ${meta.label}`}
      className="inline-flex items-end gap-[2px] align-middle"
      style={{ height: 11 }}
    >
      {[1, 2, 3].map((i) => {
        const active = i <= bars;
        const h = i === 1 ? 4 : i === 2 ? 7 : 10;
        return (
          <span
            key={i}
            className={`block w-[3px] rounded-[1px] ${
              active ? "bg-sky-400" : "bg-slate-700"
            }`}
            style={{ height: h }}
          />
        );
      })}
    </span>
  );
}
